import { render, staticRenderFns } from "./wiki-diff.vue?vue&type=template&id=2545f7ea"
import script from "./wiki-diff.vue?vue&type=script&lang=js"
export * from "./wiki-diff.vue?vue&type=script&lang=js"
import style0 from "./wiki-diff.vue?vue&type=style&index=0&id=2545f7ea&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports